import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Public/Header';
import Footer from '../components/Public/Footer';
import { SITE } from '../config/site';

export default function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Terms of Service - {SITE.name}</title>
        <meta name="description" content={`Terms of Service for ${SITE.name}`} />
        <link rel="canonical" href={`https://${SITE.domain}/terms`} />
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
          <Container maxWidth="md">
            <Paper elevation={2} sx={{ p: 4 }}>
              <Typography variant="h3" component="h1" gutterBottom>
                Terms of Service
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Last updated: {new Date().toLocaleDateString()}
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                1. Acceptance of Terms
              </Typography>
              <Typography paragraph>
                By accessing or using {SITE.name}, you agree to be bound by these Terms of Service.
                If you do not agree to these terms, please do not use our services.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                2. Description of Service
              </Typography>
              <Typography paragraph>
                {SITE.name} provides meeting transcription services, including file uploads,
                automated bot recording, calendar integration, and AI-powered summaries and action
                items.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                3. User Accounts
              </Typography>
              <Typography paragraph>
                You are responsible for maintaining the confidentiality of your account credentials
                and for all activities that occur under your account. You agree to notify us
                immediately of any unauthorized use of your account.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                4. Usage Limits and Billing
              </Typography>
              <Typography paragraph>
                Your plan includes a specific number of transcription minutes per month. Overage
                charges apply as specified in your plan. Minutes are calculated based on audio
                duration, rounded up to the nearest 15 seconds.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                5. Acceptable Use
              </Typography>
              <Typography paragraph>
                You agree not to use our services for any unlawful purpose or in any way that could
                damage, disable, or impair our services. You are responsible for ensuring you have
                the necessary rights and permissions to record and transcribe meetings.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                6. Data Ownership
              </Typography>
              <Typography paragraph>
                You retain all rights to your content, including uploaded files and meeting data. We
                do not claim ownership of your content but require a license to process it and
                provide our services.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                7. Service Availability
              </Typography>
              <Typography paragraph>
                We strive to provide reliable service but do not guarantee uninterrupted access. We
                reserve the right to modify or discontinue services with reasonable notice.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                8. Termination
              </Typography>
              <Typography paragraph>
                We may suspend or terminate your account if you violate these terms. You may cancel
                your account at any time. Upon termination, you will lose access to your data unless
                otherwise arranged.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                9. Limitation of Liability
              </Typography>
              <Typography paragraph>
                To the maximum extent permitted by law, {SITE.name} shall not be liable for any
                indirect, incidental, special, or consequential damages arising from your use of our
                services.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                10. Contact
              </Typography>
              <Typography paragraph>
                For questions about these Terms of Service, contact us at {SITE.supportEmail}.
              </Typography>
            </Paper>
          </Container>
        </Box>
        <Footer />
      </Box>
    </>
  );
}
